export default {
  data() {
    return {
      id: null,
      loading: true,
      data: {},
    }
  },
  created(){
    this.$request.assBranchCurrent().then( resp => {
      this.loading = false
      if(resp.code == 0){
        resp.data.location = [ resp.data.longitude , resp.data.latitude]
        this.data = this.$utils.conv(resp.data,{'gender':'$gender' , 'entryTime':'datetime'})
      }else{
        this.$Message.error({ content: resp.msg })
      }
    })
  },
  render(){
    const { data } = this
    return (
      <sl-page>
      <sl-detail-list col={1} label-width="100px" label-align="right" style="padding:12px;">
        <sl-detail-list-item title="站点名称">{data.repairSiteName}</sl-detail-list-item>
        <sl-detail-list-item title="联系人">{data.contact}</sl-detail-list-item>
        <sl-detail-list-item title="联系电话">{data.contactPhone}</sl-detail-list-item>
        <sl-detail-list-item title="所属区域">{data.districtName}</sl-detail-list-item>
        <sl-detail-list-item title="所在地址">{data.address}</sl-detail-list-item>
        <sl-detail-list-item title="地理位置">
          <sl-amap style="height:300px;">
            <sl-amap-marker center={data.location} cs="wgs84" />
          </sl-amap>
        </sl-detail-list-item>
{/*        <sl-detail-list-item title="银行卡号">{data.bankCard}</sl-detail-list-item>*/}
        <sl-detail-list-item title="备注">{data.remark}</sl-detail-list-item>
      </sl-detail-list>
      </sl-page>
    )
  }
}